/* Fiche « stick anti-âge calcium + collagène » (modèle product.stick-calcium, 27/10/2026, cro-pages) : copie de la fiche Naila.
   Barre d'annonce, menu, galerie, offres 1 / 1+1 / 2+1, ajout au panier en AJAX puis tiroir de la page (sections/stk-panier,
   même mécanique que assets/ft.js), barre collante, minuteurs, carrousels, « Lire la suite », vidéos lues à l'écran.
   Suivi CRO : clics marqués data-cro lus par cro-tracker.js ; ouverture du tiroir lue sur [data-cro-panier-lateral]. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LG = document.documentElement.lang || 'fr';
  var T = $('[data-stk-t]') ? JSON.parse($('[data-stk-t]').textContent) : {};
  var d2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var post = function (url, corps) {
    return fetch(racine + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) });
  };

  /* ── Barre d'annonce : un message toutes les 4 s, flèches ── */
  (function () {
    var a = $('[data-stk-annonce]'); if (!a) return;
    var m = $$('.stk-annonce__pistes p', a), i = 0, t;
    function voir(k) { i = (k + m.length) % m.length; m.forEach(function (p, j) { p.classList.toggle('is-on', j === i); }); }
    function auto() { clearInterval(t); t = setInterval(function () { voir(i + 1); }, 4000); }
    $$('[data-stk-annonce-fl]', a).forEach(function (b) { b.addEventListener('click', function () { voir(i + +b.dataset.stkAnnonceFl); auto(); }); });
    auto();
  })();

  /* ── Menu ── */
  (function () {
    var t = $('[data-stk-menu]'); if (!t) return;
    document.body.appendChild(t);
    $$('[data-stk-menu-ouvrir]').forEach(function (b) { b.addEventListener('click', function () { t.hidden = false; document.documentElement.style.overflow = 'hidden'; }); });
    $$('[data-stk-menu-fermer]', t).forEach(function (b) { b.addEventListener('click', function () { t.hidden = true; document.documentElement.style.overflow = ''; }); });
  })();

  /* ── Compteur du panier de l'en-tête ── */
  function majCompte() {
    fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-stk-compte]').forEach(function (e) { e.textContent = c.item_count; e.hidden = !c.item_count; });
    }).catch(function () {});
  }
  window.addEventListener('ajaxCart', majCompte);

  /* ── Tiroir de la page : dates de la frise (Intl, langue de la page), avis recopiés de la section stk-avis ── */
  function tiroirMaj(b) {
    var lg = LG === 'no' ? 'nb' : LG, d = function (t) { return new Date(+t * 1000); };
    $$('[data-stk-jour]', b).forEach(function (e) {
      try { e.textContent = new Intl.DateTimeFormat(lg, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d(e.dataset.stkJour)); }
      catch (x) { e.textContent = d(e.dataset.stkJour).toLocaleDateString(); }
    });
    $$('[data-stk-plage]', b).forEach(function (e) {
      var t = e.dataset.stkPlage.split('|'), f;
      try { f = new Intl.DateTimeFormat(lg, { day: 'numeric', month: 'short', timeZone: 'UTC' }); e.textContent = f.formatRange ? f.formatRange(d(t[0]), d(t[1])) : f.format(d(t[0])) + ' – ' + f.format(d(t[1])); }
      catch (x) { e.textContent = d(t[0]).toLocaleDateString() + ' – ' + d(t[1]).toLocaleDateString(); }
    });
    var car = $('[data-stkp-car]', b), pts = $('[data-stkp-points]', b);
    if (car && !car.children.length) {
      $$('#stk-avis .stk-avis__carte').slice(0, 6).forEach(function (c, k) {
        var a = document.createElement('div'); a.className = 'stkp-avis';
        var et = $('.stk-etoiles', c), h = $('h3', c), tx = $('.stk-avis__txt', c), nom = $('header strong', c);
        a.innerHTML = '<div class="stkp-avis-tete"></div><p class="stkp-avis-t"></p><p class="stkp-avis-txt"></p><button type="button" class="stk-lien" data-stkp-plus data-cro="avis_lire_plus" data-cro-value="tiroir-' + (k + 1) + '"></button><p class="stkp-avis-nom"></p>';
        if (et) $('.stkp-avis-tete', a).appendChild(et.cloneNode(true));
        $('.stkp-avis-t', a).textContent = h ? h.textContent : '';
        $('.stkp-avis-txt', a).innerHTML = tx ? tx.innerHTML : '';
        $('[data-stkp-plus]', a).textContent = T.plus || '+';
        $('.stkp-avis-nom', a).textContent = nom ? nom.textContent : '';
        car.appendChild(a);
        if (pts) { var p = document.createElement('i'); if (!k) p.className = 'on'; pts.appendChild(p); }
      });
      car.addEventListener('scroll', function () {
        var c = car.children[0]; if (!c || !pts) return;
        var i = Math.round(car.scrollLeft / (c.offsetWidth + 8));
        Array.prototype.forEach.call(pts.children, function (p, k) { p.classList.toggle('on', k === i); });
      }, { passive: true });
    }
  }

  var panier = (function () {
    var b = $('[data-stk-panier]'); if (!b) return null;
    document.body.appendChild(b);
    var tiroir = $('.stk-panier__tiroir', b);
    $$('[data-cro-panier-lateral]').forEach(function (e) { e.removeAttribute('data-cro-panier-lateral'); });
    tiroir.setAttribute('data-cro-panier-lateral', '');
    var CLE = 'sloown-panier-expire', DUREE = 15 * 60 * 1000;
    function nb() { var i = $('[data-stk-panier-in]', b); return i ? +i.dataset.nb : 0; }
    function minuteur() {
      var fin = 0;
      try {
        fin = +localStorage.getItem(CLE) || 0;
        if (!nb()) { localStorage.removeItem(CLE); fin = 0; }
        else if (!fin) { fin = Date.now() + DUREE; localStorage.setItem(CLE, fin); }
      } catch (x) {}
      var r = fin ? Math.max(0, Math.round((fin - Date.now()) / 1000)) : 0;
      $$('[data-stk-minuteur-temps]', b).forEach(function (e) { e.textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60); });
      $$('[data-stk-minuteur]', b).forEach(function (e) { e.hidden = !r; });
    }
    setInterval(function () { if (!b.hidden) minuteur(); }, 1000);
    function ouvrir() {
      b.hidden = false; minuteur(); tiroirMaj(b);
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-ouvert'); tiroir.setAttribute('aria-hidden', 'false'); }); });
    }
    function fermer() {
      b.classList.remove('is-ouvert'); tiroir.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!b.classList.contains('is-ouvert')) b.hidden = true; }, 300);
    }
    function recharger() {
      var sid = b.dataset.sid;
      return fetch(location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sec) {
        var d = document.createElement('div'); d.innerHTML = sec[sid];
        var neuf = $('[data-stk-panier-in]', d), vieux = $('[data-stk-panier-in]', b);
        if (neuf && vieux) vieux.parentNode.replaceChild(neuf, vieux);
        tiroirMaj(b);
        // Minuteur du thème (layout/theme.liquid) : il lit le nombre d'articles sur son tiroir, jamais rechargé ici.
        var c = $('#cart'), t = $('#cart [data-totalqty]');
        if (c && !t) { t = document.createElement('div'); t.hidden = true; c.appendChild(t); }
        if (t) t.setAttribute('data-totalqty', nb());
        minuteur(); majCompte();
      });
    }
    b.addEventListener('click', function (e) {
      if (e.target.closest('[data-stk-panier-fermer]')) { fermer(); return; }
      var pl = e.target.closest('[data-stkp-plus]');
      if (pl) { var av = pl.closest('.stkp-avis'); if (av) { var o = av.classList.toggle('is-ouvert'); pl.textContent = o ? T.moins : T.plus; } return; }
      var aj = e.target.closest('[data-stk-panier-ajout]');
      if (aj) {
        $('[data-stk-panier-in]', b).classList.add('is-maj');
        post('cart/add.js', { items: [{ id: +aj.dataset.stkPanierAjout, quantity: 1 }] }).then(recharger, recharger).catch(function () { location.href = racine + 'cart'; });
        return;
      }
      var q = e.target.closest('[data-stk-qte]'); if (!q) return;
      var l = q.closest('[data-ligne]'), n = Math.max(0, +l.dataset.q + +q.dataset.stkQte);
      $('[data-stk-panier-in]', b).classList.add('is-maj');
      post('cart/change.js', { line: +l.dataset.ligne, quantity: n }).then(recharger).catch(function () { location.href = racine + 'cart'; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !b.hidden) fermer(); });
    $$('[data-stk-panier-ouvrir]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); recharger().catch(function () {}); }); });
    return { ouvrir: ouvrir, recharger: recharger };
  })();

  /* ── Liens vers une partie de la page (note → avis, boutons → offres) ── */
  $$('[data-stk-vers]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var c = $(a.getAttribute('data-stk-vers')); if (!c) return;
      e.preventDefault();
      var h = ($('.stk-entete') || {}).offsetHeight || 0;
      window.scrollTo({ top: c.getBoundingClientRect().top + window.pageYOffset - h - 12, behavior: 'smooth' });
    });
  });

  /* ── Carrousels d'avis : flèches (une carte) ── */
  $$('[data-stk-car]').forEach(function (c) {
    var p = $('[data-stk-car-piste]', c);
    $$('[data-stk-car-fl]', c).forEach(function (f) {
      f.addEventListener('click', function () { var k = p.children[0]; p.scrollBy({ left: +f.dataset.stkCarFl * ((k ? k.offsetWidth : 300) + 16), behavior: 'smooth' }); });
    });
  });

  /* ── « Lire la suite » des avis (seulement si le texte est coupé) ── */
  $$('[data-stk-plus]').forEach(function (b) {
    var txt = b.previousElementSibling;
    function besoin() { b.hidden = !txt.classList.contains('is-ouvert') && txt.scrollHeight <= txt.clientHeight + 2; }
    b.addEventListener('click', function () { var o = txt.classList.toggle('is-ouvert'); b.textContent = o ? T.moins : T.plus; });
    besoin(); window.addEventListener('resize', besoin);
  });

  /* ── « Toutes les notes » sous le carrousel : notes sans commentaire (étoiles + date), filtre par étoiles, 24 par 24 ── */
  (function () {
    var z = $('[data-stk-notes]'); if (!z) return;
    var notes; try { notes = JSON.parse($('[data-stk-notes-json]', z).textContent) || []; } catch (e) { return; }
    var grille = $('[data-stk-notes-grille]', z), plus = $('[data-stk-notes-plus]', z), filtres = $('[data-stk-notes-filtres]', z);
    var pas = +z.dataset.pas || 24, vu = pas, filtre = 0, lang = document.documentElement.lang || 'fr', fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { fmt = null; }
    var etoile = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.8 6.6 7.1.6-5.4 4.7 1.6 7-6.1-3.7-6.1 3.7 1.6-7L2.1 9.7l7.1-.6z"/></svg>';
    function etoiles(n) { var h = ''; for (var i = 1; i <= 5; i++) h += '<span class="stk-etoile" style="--p: ' + (i <= n ? 100 : 0) + '%">' + etoile + '</span>'; return '<span class="stk-etoiles" aria-label="' + n + '/5">' + h + '</span>'; }
    function jour(d) { var p = String(d || '').split('-'); if (p.length !== 3 || !fmt) return d || ''; return fmt.format(new Date(+p[0], +p[1] - 1, +p[2])); }
    var nb = [0, 0, 0, 0, 0, 0]; notes.forEach(function (x) { nb[+x[0]] = (nb[+x[0]] || 0) + 1; });
    var h = '<button type="button" aria-pressed="true" data-n="0">' + z.dataset.txtToutes + '</button>';
    for (var k = 5; k >= 1; k--) if (nb[k]) h += '<button type="button" aria-pressed="false" data-n="' + k + '" data-cro="avis_notes_filtre" data-cro-value="' + k + '">' + k + '★ <small>' + nb[k] + '</small></button>';
    filtres.innerHTML = h;
    function dessiner() {
      var L = filtre ? notes.filter(function (x) { return +x[0] === filtre; }) : notes;
      grille.innerHTML = L.slice(0, vu).map(function (x) { return '<li>' + etoiles(+x[0]) + '<time>' + jour(x[1]) + '</time></li>'; }).join('');
      plus.hidden = L.length <= vu;
    }
    filtres.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      filtre = +b.dataset.n; vu = pas;
      $$('button', filtres).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      dessiner();
    });
    plus.addEventListener('click', function () { vu += pas; dessiner(); });
    dessiner();
  })();

  /* ── Vidéos : chargées et lues seulement à l'écran, en pause sinon ── */
  (function () {
    var vs = $$('[data-stk-video]'); if (!vs.length) return;
    if (!window.IntersectionObserver) { vs.forEach(function (v) { v.src = v.dataset.src; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.src) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vs.forEach(function (v) { io.observe(v); });
  })();

  /* ── Minuteurs d'offre (Naila : « se termine dans 12:45 ») : 15 min qui repartent, gardées pour la visite ── */
  (function () {
    var cs = $$('[data-stk-chrono]'); if (!cs.length) return;
    var fin = 0;
    try { fin = +sessionStorage.getItem('stk-chrono') || 0; } catch (x) {}
    function tic() {
      if (fin <= Date.now()) { fin = Date.now() + 15 * 60 * 1000; try { sessionStorage.setItem('stk-chrono', fin); } catch (x) {} }
      var r = Math.round((fin - Date.now()) / 1000);
      cs.forEach(function (c) { c.textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60); });
    }
    tic(); setInterval(tic, 1000);
  })();

  /* ── Pied de page : menus ouverts sur ordinateur ── */
  function piedOuvert() { if (window.matchMedia('(min-width: 990px)').matches) $$('.stk-pied__col').forEach(function (d) { d.open = true; }); }
  piedOuvert();

  var P = $('[data-stk-produit]');
  if (!P) return;

  /* ── Galerie : flèches, vignettes ↔ photo affichée ── */
  (function () {
    var piste = $('[data-stk-piste]', P), vigs = $$('.stk-galerie__vig', P), bv = $('[data-stk-vigs]', P);
    if (!piste) return;
    function courant() { return Math.round(piste.scrollLeft / piste.clientWidth); }
    function aller(i) { piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' }); }
    function majVig() {
      var i = courant();
      vigs.forEach(function (v, k) { v.classList.toggle('is-on', k === i); });
      if (vigs[i] && bv) bv.scrollTo({ left: vigs[i].offsetLeft - bv.clientWidth / 2 + vigs[i].clientWidth / 2, behavior: 'smooth' });
    }
    vigs.forEach(function (v) { v.addEventListener('click', function () { aller(+v.dataset.i); }); });
    $$('[data-stk-gal]', P).forEach(function (f) {
      f.addEventListener('click', function () { var n = piste.children.length, i = courant() + +f.dataset.stkGal; aller((i + n) % n); });
    });
    var t; piste.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(majVig, 90); }, { passive: true });
  })();

  /* ── Offres (variante du lot envoyée au panier ; snippets/rs-lots la change en unité × q) ── */
  var offres = $$('[data-stk-offre]', P), champId = $('[data-stk-id]', P);
  function offre() { return offres.filter(function (o) { return o.classList.contains('is-on'); })[0] || offres[0]; }
  offres.forEach(function (o) {
    function choisir() {
      offres.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
      champId.value = o.dataset.id;
    }
    o.addEventListener('click', choisir);
    o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choisir(); } });
  });
  // ?offre=1|2|3 dans l'adresse coche cette offre (liens des futurs advertoriaux)
  (function () { var m = /[?&]offre=([123])/.exec(location.search), o = m && $('[data-stk-offre="' + m[1] + '"]', P); if (o) o.click(); })();

  /* ── Ajout au panier : vrai formulaire /cart/add (suivi CRO), envoyé en AJAX puis tiroir de la page ── */
  var form = $('[data-stk-form]', P), bouton = $('[data-stk-ajout]', P), err = $('[data-stk-erreur]', P);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (offre().dataset.dispo !== 'true') { err.textContent = T.indispo; err.hidden = false; return; }
    err.hidden = true; bouton.disabled = true;
    fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        bouton.disabled = false;
        if (!panier) { location.href = racine + 'cart'; return; }
        return panier.recharger().then(panier.ouvrir).catch(function () { location.href = racine + 'cart'; });
      })
      .catch(function (d) { bouton.disabled = false; err.textContent = (d && (d.description || d.message)) || T.erreur; err.hidden = false; });
  });

  /* ── Barre d'achat collante : visible une fois le bouton « Ajouter au panier » dépassé ── */
  (function () {
    var st = $('[data-stk-sticky]', P); if (!st || !window.IntersectionObserver) return;
    document.body.appendChild(st);
    new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true');
    }).observe(bouton);
  })();

  /* ── Pays de livraison : pays réel (en-tête Server-Timing « country », comme ft.js), sinon France ── */
  (function () {
    var e = $('[data-stk-pays]', P); if (!e) return;
    var code = null;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      ((nav && nav.serverTiming) || []).forEach(function (s) { if (s.name === 'country') code = s.description; });
      if (!code) code = sessionStorage.getItem('rs_pays');
    } catch (x) {}
    if (!code || !/^[A-Z]{2}$/.test(code) || code === e.dataset.code) return;
    var nom = code;
    try { nom = new Intl.DisplayNames([LG], { type: 'region' }).of(code); } catch (x) {}
    $('[data-stk-drapeau]', e).src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=32';
    $('[data-stk-pays-txt]', e).textContent = e.dataset.modele.replace('[p]', nom);
  })();
})();
